export default {
  bookExperiencePanel: '預訂體驗面板',
  calendarIcon: '日曆圖示',
  coverImageForResource: '{{title}} 體驗的封面圖片',
  filterBy: '按 {{filter}} 篩選',
  filterByDateRange: '按日期範圍篩選',
  gallery: '圖庫',
  goBack: '返回上一頁',
  hostUserIcon: '主持人圖示',
  imageOf: '{{title}} 的圖片',
  interactiveMapAltText: '包含可選擇的 {{title}} 的互動地圖',
  mediaSlides: '媒體投影片',
  muteVideo: '靜音影片',
  nextPhoto: '下一張照片',
  noVideoPlayback: '無法播放影片',
  pauseVideo: '暫停影片',
  photoOf: '{{name}} 的照片',
  playVideo: '播放影片',
  previousPhoto: '上一張照片',
  moreFiltersAndExperiences: '更多篩選條件和體驗',
  reserveSelectedSlot: '預約選定時段',
  reviewRating: '評論評分 5 分中的 {{rating}} 分',
  overallReviewRating: '整體評論評分 5 分中的 {{rating}} 分',
  selectCountryCodeForPhoneNumber: '選擇電話號碼國家代碼',
  selectDate: '選擇日期',
  selectParticipants: '選擇參加者',
  selectSessionTime: '選擇時段',
  unmuteVideo: '取消靜音影片',
  viewShoppingCart: '查看購物車',
  itemsInCart: '{{count}} 個物品在購物車中',
  zoomIn: '放大',
  zoomOut: '縮小',
  selectData: '選擇 {{data}}',
  reserveName: '預訂 {{name}}',
  deleteReservation: '刪除 {{experienceTitle}} 預訂',
  editParticipantsFor: '編輯 {{experienceTitle}} 的參加者',
  enterPromoCode: '輸入優惠碼',
  applyPromoCode: '套用優惠碼',
  increaseAddOnAmount: '增加 {{addOn}} 選項',
  decreaseAddOnAmount: '減少 {{addOn}} 選項',
  addOnModal: '{{addOn}} 選項視窗',
  moreInformationAboutAddOn: '更多關於 {{addOn}} 的資訊',
  decreasePriceTierTickets: '減少 {{priceTier}} 票數',
  increasePriceTierTickets: '增加 {{priceTier}} 票數',
  downloadFilename: '下載 {{filename}}',
  viewFullDetailsDescription: '查看完整詳細資訊',
  viewFullDescription: '查看完整描述',
  closeModal: '關閉視窗',
  hyattBanner: '凱悅天地會員專屬橫幅',
  hyattBannerDesc: '宣傳橫幅，顯示提供給凱悅天地忠誠計劃會員的專屬福利和優惠',
  previousSlide: '上一張幻燈片',
  nextSlide: '下一張幻燈片',
  paginationBulletMessage: '轉到幻燈片',
  exitFullscreen: '退出全屏模式',
  enterFullscreen: '進入全屏模式',
  videoSlide: '視頻幻燈片',
  imageSlide: '圖像幻燈片',
  of: '的',
  noDescription: '沒有描述',
  mediaGallery: '輪播 - 媒體畫廊',
  dateSelector: '日期選擇器',
  nextWeek: '下一週',
  previousWeek: '上一週',
  scheduleAgenda: '行程安排',
  scheduleNav: '行程導覽',
  scheduleViewSelector: '行程視圖選擇器',
  selectedDateAriaLabel: '{{date}}，已選擇',
  tapToBookExperience: '預訂 {{title}}',
  bookExperienceAriaLabel: '預訂 {{title}}',
  joinWaitlistAriaLabel: '加入 {{title}} 候補名單',
};
